import request from "root/js/request";

export const getExpenseCounterpartiesCrossMP = async ({ cabinet_id, ...rest }) => {
  const response = await request({
    url: "/analytics/cross-mp/expense/counterparty/",
    method: "get",
    params: {
      cabinet_id,
      ...rest,
    },
  });
  return response.data;
};

export const getExpenseCounterpartyCrossMPById = async ({
  cabinet_id,
  counterparty_id,
  ...rest
}) => {
  const response = await request({
    url: `/analytics/cross-mp/expense/counterparty/${counterparty_id}/`,
    method: "get",
    params: {
      cabinet_id,
      ...rest,
    },
  });
  return response.data;
};

export const postCreateExpenseCounterpartyCrossMP = async ({
  cabinet_id,
  name,
  counterparty_type,
  ...rest
}) => {
  const response = await request({
    url: `/analytics/cross-mp/expense/counterparty/`,
    method: "post",
    params: {
      cabinet_id,
      name,
      counterparty_type,
      ...rest,
    },
  });
  return response.data;
};

export const putEditExpenseCounterpartyCrossMPById = async ({
  cabinet_id,
  counterparty_id,
  ...rest
}) => {
  const response = await request({
    url: `/analytics/cross-mp/expense/counterparty/${counterparty_id}/`,
    method: "put",
    params: {
      cabinet_id,
      ...rest,
    },
  });
  return response.data;
};

export const deleteExpenseCounterpartyCrossMPById = async ({
  cabinet_id,
  counterparty_id,
  ...rest
}) => {
  const response = await request({
    url: `/analytics/cross-mp/expense/counterparty/${counterparty_id}/`,
    method: "delete",
    params: {
      cabinet_id,
      ...rest,
    },
  });
  return response.data;
};